import React from 'react';
import FlowRemind from 'components/Home/FlowRemind';
import { IFlowItems } from 'components/Home/FlowRemind/Flow/types';

type IProps = {}
const ClaimsFlow: React.FC<IProps> = (props) => {
  const flowItems: IFlowItems[] = [
    {
      title: 'STEP1',
      title2: <p className="color-red">前往指定獸醫院就診</p>,
      icon: require('../../../assets/images/Claims-process-01.png'),
      text: '',
      desc: (
        <p>請參考理賠流程圖，至指定獸醫院就診
          <a href="https://petscare.ai/Healthy/VetHospital/" target="_blank" rel="noopener noreferrer" className="element__link">[查詢獸醫院據點]</a>
          建議以電腦(網頁)方式開啟連結。於指定獸醫院就診時告知為旺旺友聯保戶，若經指定獸醫院評估須轉診且開立轉診單者，得前往該轉診獸醫院就診。
        </p>
      )
    },
    {
      title: 'STEP2',
      title2: <p className="color-red">取得相關理賠文件</p>,
      icon: require('../../../assets/images/Claims-process-02.png'),
      text: '',
      desc: <p>至指定獸醫院就診結束療程後，與醫院告知欲申請保險，確認數位診療資料內容無誤。若有轉診，請向非指定獸醫院索取「診斷證明書」、「醫療收據」正本。若申請其他項目理賠，請參照QA指示備妥應備文件。</p>
    },
    {
      title: 'STEP3',
      title2: <p className="color-red">填寫理賠申請書並寄出</p>,
      icon: require('../../../assets/images/Claims-process-03.png'),
      text: '',
      desc: (
        <div>
          <p>至官網【理賠服務】取得理賠申請書填寫完成後，將理賠文件及理賠申請書郵寄至旺旺友聯理賠部門。</p>
          <p className="color-red">請勿同意獸醫院代收理賠文件，以保護您的個資安全及理賠權益。</p>
        </div>
      )
    },
    {
      title: 'STEP4',
      title2: <p className="color-red">取得理賠金</p>,
      icon: require('../../../assets/images/Claims-process-04.png'),
      text: '',
      desc: <p>本公司收到完整理賠文件15天內，將理賠金匯入指定帳戶。</p>
    }
  ];
  return (
    <>
      <FlowRemind.Flow
        name="clames-flow-mobile-items-slider"
        items={flowItems}
        itemIconStyles={{ marginBottom: '10px' }}
      />
    </>
  );
};

export default ClaimsFlow;
